import { useEffect, useState } from 'react';

// Reports whether `targetRef` sits entirely inside `rootRef`'s clip box — i.e.
// the conveyor isn't cutting the tile off at either edge. Backed by an
// IntersectionObserver rooted at the viewport, so it accounts for the track's
// transform without reading layout on every scroll frame.
export function useFullyInView(
  targetRef: React.RefObject<Element>,
  rootRef: React.RefObject<Element>,
  // Ratios this close to 1 count as fully visible (guards subpixel rounding,
  // which can otherwise keep the ratio at 0.999 and never reach exactly 1).
  tolerance = 0.99,
): boolean {
  const [fullyVisible, setFullyVisible] = useState(false);

  useEffect(() => {
    const target = targetRef.current;
    const root = rootRef.current;
    if (!target || !root) return undefined;

    const observer = new IntersectionObserver(([entry]) => setFullyVisible(entry.intersectionRatio >= tolerance), {
      root,
      threshold: [0, tolerance, 1],
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [targetRef, rootRef, tolerance]);

  return fullyVisible;
}
